import React from 'react';
import { Button } from '@/components/ui/button';

// Read-only "Data source: … · Change in Settings" line (FIG-345 UC-229; shared
// in FIG-409). The source is saved per merchant in Settings › Reports and
// Charts › Data sources; reports and charts only show it. Used by the Reports
// tab and the Overview Daily NERV Trends chart.

interface DataSourceLineProps {
  /** e.g. "Data source:" or "Data source (shared with ∑: Variants):" */
  prefix?: string;
  /** "All Sources", the source name, or "N sources selected". */
  label: string;
  /** Optional note, e.g. a saved source that is no longer connected. */
  note?: string | null;
  /** Opens the Settings tab; the link is hidden without it. */
  onOpenSettings?: () => void;
  testId?: string;
}

export const DataSourceLine: React.FC<DataSourceLineProps> = ({
  prefix = 'Data source:',
  label,
  note,
  onOpenSettings,
  testId = 'report-data-source',
}) => (
  <div className="flex items-center gap-1.5 text-sm" data-testid={testId}>
    <span className="text-muted-foreground">{prefix}</span>
    <span className="font-medium">{label}</span>
    {onOpenSettings && (
      <>
        <span className="text-muted-foreground" aria-hidden="true">·</span>
        <Button type="button" variant="link" size="sm" className="h-auto p-0 text-sm" onClick={onOpenSettings}>
          Change in Settings
        </Button>
      </>
    )}
    {note && <span className="text-xs text-muted-foreground">({note})</span>}
  </div>
);

export default DataSourceLine;
